import { Component } from '@angular/core';
import 'moment/locale/id';
import { BatteryRentRestService } from '../battery-rent-rest.service';
import Swal from 'sweetalert2';
import { APP_CONST } from '../../../app.const';
import { BatteryRentListComponent } from '../list/battery-rent-list.component';

@Component({
  selector: 'app-customer-modal',
  templateUrl: 'add-customer.component.html',
  styleUrls: ['../list/battery-rent-list.component.scss']
})
export class AddCustomerModalComponent {
  isModalOpen: boolean = false;
  nikInput: string = ''; // To hold user input for NIK
  customerData: any = null; // To store fetched customer data
  selectedCustomer: any = null;
  isCustomerLoading: boolean = false;
  provinces: any;
  isProvinceLoading: boolean = false;
  cities: any;
  isCityLoading: boolean = false;
  motorcycleTypes: any;
  isMotorcycleTypeLoading: boolean = false;
  availableColors: Array<{ id: number; code: string; color: string }> = [];
  isSubmitting: boolean = false;
  formData: {
    nik: string,
    customerName: string,
    customerPhone: string,
    province: string,
    city: string,
    customerAddress: string,
    motorcycleNumber: string,
    chassisNumber: string,
    engineNumber: string,
    yearOfManufacture: string,
    purchaseDate: string,
    motorcycleType: string,
    motorcycleColor: string,
    invoice: string,
    invoiceUrl?: string,
    pks: string,
    pksUrl?: string,
    province_id: number,
    city_id: number,
    motor_type_id: number,
  } = {
    nik: '',
    customerName: '',
    customerPhone: '',
    province: '',
    city: '',
    customerAddress: '',
    motorcycleNumber: '',
    chassisNumber: '',
    engineNumber: '',
    yearOfManufacture: '',
    purchaseDate: '',
    motorcycleType: '',
    motorcycleColor: '',
    invoice: '',
    invoiceUrl: '',
    pks: '',
    pksUrl: '',
    province_id: null,
    city_id: null,
    motor_type_id: null,
  }

  onMotorcycleNumberChange(index: number) {
    this.selectedCustomer = this.customerData[index];
  }

  constructor(
    private _BatteryRentRest: BatteryRentRestService,

    public _batteryRentListComponent: BatteryRentListComponent,
  ) {}

  allowOnlyNumber(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    // Hanya angka (0-9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  openModal() {
    this.isModalOpen = true;
    this.customerData = null; // Reset customer data when modal is opened
    this.nikInput = ''; // Clear NIK input
    this.fetchProvinces();
    this.fetchMotorcycleTypes();
    this.formData.motorcycleNumber = this.generatedMotorcycleNumber();
  }

  closeModal() {
    this.isModalOpen = false;
    this.resetModal();
  }

  resetModal() {
    this.formData = {
      nik: '',
      customerName: '',
      customerPhone: '',
      province: '',
      city: '',
      customerAddress: '',
      motorcycleNumber: '',
      chassisNumber: '',
      engineNumber: '',
      yearOfManufacture: '',
      purchaseDate: '',
      motorcycleType: '',
      motorcycleColor: '',
      invoice: '',
      invoiceUrl: '',
      pks: '',
      pksUrl: '',
      province_id: null,
      city_id: null,
      motor_type_id: null,
    };
  }

  generatedMotorcycleNumber(): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*';
    let result = '';
    for (let i = 0; i < 8; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return `VOLTA-${result}`;
  }

  onMotorcycleTypeChange(event: Event) {
    const selectedTypeName = (event.target as HTMLSelectElement).value;
    const selectedType = this.motorcycleTypes.find(type => type.name === selectedTypeName);

    if (selectedType) {
      this.availableColors = selectedType.colors || [];
      this.formData.motorcycleColor = ''; // Reset pilihan warna
    } else {
      this.availableColors = [];
      this.formData.motorcycleColor = '';
    }
  }
  onProvinceChange(event: Event) {
    const selectedProvinceName = (event.target as HTMLSelectElement).value;
    const selectedProvince = this.provinces.find(
      prov => prov.name === selectedProvinceName
    );

    if (selectedProvince) {
      this.formData.city = ''; // clear selected city
      this.formData.province_id = selectedProvince.id; // assign province_id
      this.isCityLoading = true;
      this.fetchCities(selectedProvince.id);
    } else {
      this.cities = [];
      this.formData.city = '';
      this.formData.province_id = null; // reset province_id if not found
    }
  }

  onCityChange(event: Event) {
    const selectedCityName = (event.target as HTMLSelectElement).value;
    const selectedCity = this.cities.find(
      city => city.name === selectedCityName
    );

    if (selectedCity) {
      this.formData.city_id = selectedCity.id; // assign city_id
    } else {
      this.formData.city = '';
      this.formData.city_id = null; // reset city_id if not found
    }
  }

  onMotorcycleColorChange(event: Event) {
    const selectedMotorcycleColorName = (event.target as HTMLSelectElement).value;
    const selectedMotorcycleColor = this.availableColors.find(
      color => color.color === selectedMotorcycleColorName
    );

    if (selectedMotorcycleColor) {
      this.formData.motor_type_id = selectedMotorcycleColor.id; // assign motor_type_id
    } else {
      this.formData.motor_type_id = null; // reset motor_type_id if not found
    }
  }


  fetchProvinces() {
      this._BatteryRentRest.getProvinces().subscribe({
      next: response => {
        this.provinces = response.data;
        this.isProvinceLoading = false;
      },
      error: err => {
        Swal.fire('Error', 'Data provinsi gagal diambil.', 'error');
        this.isProvinceLoading = false;
      }
    });
  }

  fetchCities(province_id: number) {
      this._BatteryRentRest.getCities(province_id).subscribe({
      next: response => {
        this.cities = response.data;
        this.isCityLoading = false;
      },
      error: err => {
        Swal.fire('Error', 'Data kota gagal diambil.', 'error');
        this.isCityLoading = false;
      }
    });
  }

  fetchMotorcycleTypes() {
      this._BatteryRentRest.getMotorcycleTypes().subscribe({
      next: response => {
        this.motorcycleTypes = response.data;
        this.isMotorcycleTypeLoading = false;
      },
      error: err => {
        Swal.fire('Error', 'Data tipe motor gagal diambil.', 'error');
        this.isMotorcycleTypeLoading = false;
      }
    });
  }

  // Map field keys to human-readable names
  private fieldNames: { [key: string]: string } = {
    nik: 'NIK',
    customerName: 'Nama Pelanggan',
    customerPhone: 'Nomor Telepon',
    province: 'Provinsi',
    city: 'Kota',
    customerAddress: 'Alamat Pelanggan',
    motorcycleNumber: 'Nomor Motor',
    chassisNumber: 'Nomor Rangka',
    engineNumber: 'Nomor Mesin',
    yearOfManufacture: 'Tahun Pembuatan',
    purchaseDate: 'Tanggal Pembelian',
    motorcycleType: 'Tipe Motor',
    motorcycleColor: 'Warna Motor',
    invoice: 'Bukti Pembayaran',
    pks: 'BAST',
    province_id: 'Provinsi',
    city_id: 'Kota',
    motor_type_id: 'Tipe Motor',
  };

  // Method to handle the submit action
  submitForm() {
    if (!this.customFormValidation()) {
      return;
    }

    this.isSubmitting = true;
    
    this._BatteryRentRest.createCustomer(this.formData).subscribe({
      next: response => {
        Swal.fire('Success', 'Data baterai sewa berhasil ditambah!', 'success');
        this._batteryRentListComponent.callHookDirectly('init');
        this.closeModal(); // Close modal on success
        this.isSubmitting = false;
      },
      error: err => {
        console.error('Error submitting form:', err);
        Swal.fire('Error', `Gagal menambahkan data baterai sewa. ${err.response?.data?.message}`, 'error');
        this.isSubmitting = false;
      }
    });
  }

  customFormValidation(): boolean {
    for (const key in this.formData) {
      if (
        this.formData[key] === '' ||
        this.formData[key] === null ||
        this.formData[key] === undefined
      ) {
        const fieldName = this.fieldNames[key] || key;
        Swal.fire('Error', `${fieldName} wajib diisi.`, 'error');
        return false;
      }
    }
    return true;
  }
}
